import { c as _c } from "react/compiler-runtime";
import { CheckIcon, Copy03Icon } from '@systemeio/icons';
import { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'shared/components/tooltip';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { copyTextToClipboard } from 'shared/utils/copy-text-to-clipboard';
import { twMerge } from 'tailwind-merge';
interface CopyInputValueButtonProps {
  className?: string;
  disabled?: boolean;
  onCopy?: () => void;
  text: string;
}
function CopyInputValueButton(t0) {
  const $ = _c(20);
  const {
    className,
    disabled,
    onCopy,
    text
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [isCopied, setIsCopied] = useState(false);
  const copiedTimeoutRef = useRef(undefined);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => () => {
      if (copiedTimeoutRef.current) {
        clearTimeout(copiedTimeoutRef.current);
      }
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== onCopy || $[3] !== text) {
    t3 = async () => {
      const copied = await copyTextToClipboard(text, false);
      if (!copied) {
        setIsCopied(false);
        return;
      }
      onCopy?.();
      setIsCopied(true);
      if (copiedTimeoutRef.current) {
        clearTimeout(copiedTimeoutRef.current);
      }
      copiedTimeoutRef.current = setTimeout(() => setIsCopied(false), 1500);
    };
    $[2] = onCopy;
    $[3] = text;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleCopy = t3;
  let t4;
  if ($[5] !== t) {
    t4 = t("global.copy");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== className) {
    t5 = twMerge("focus-visible:[&_svg]:text-icon-accent focus-visible:focus-ring-primary outline-none", className);
    $[7] = className;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== handleCopy) {
    t6 = () => void handleCopy();
    $[9] = handleCopy;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== isCopied || $[12] !== t) {
    t7 = isCopied ? <Tooltip label={isCopied ? t("global.copy_clipboard") : t("global.copy")}><CheckIcon aria-hidden="true" className="text-icon-accent size-4" /></Tooltip> : <Tooltip label={isCopied ? t("global.copy_clipboard") : t("global.copy")}><Copy03Icon aria-hidden="true" className="text-icon-secondary hover:text-icon-accent transition-base size-4" /></Tooltip>;
    $[11] = isCopied;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== disabled || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = <button aria-label={t4} className={t5} disabled={disabled} onClick={t6} type="button">{t7}</button>;
    $[14] = disabled;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
export { CopyInputValueButton };
export type { CopyInputValueButtonProps };